import { useHotelFiltersForm } from "@website/accommodation-ui/hotel-filter/hotel-filter.hook";
import { UseHotelFiltersFormProperties } from "@website/accommodation-ui/hotel-filter/hotel-filter.types";
import { deepCompare } from "@website/utils/deep-compare";
import { Filters } from "@website/widget/filter";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<UseHotelFiltersFormProperties> = (properties) => {
  const { filtersSchema, mapFilterProps, trackingCallback } = properties;
  const { resetButtonProps, onResetFilters, title, footerProps } =
    useHotelFiltersForm(properties);
  const router = useRouter();
  return (
    <Filters
      key={`${String(router?.query?.["cityTitle"])}-${String(
        router?.query?.["date_from"]
      )}-${String(router?.query?.["date_to"])}-${String(
        router?.query?.["discounted"]
      )}-${String(router?.query?.["availability"])}`}
      mapFilterProps={mapFilterProps}
      onResetFilters={onResetFilters}
      trackingCallback={trackingCallback}
      resetButtonProps={resetButtonProps}
      schema={filtersSchema}
      title={title}
      {...footerProps}
    />
  );
};

export const HotelFilter = memo(Component, deepCompare);
